import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import { Container, Row, Col } from 'react-bootstrap'

import Header from './header'
import Footer from './footer'
import ScrollButton from '../scroll-button'
import Seo from '../seo'

if (typeof window !== 'undefined') {
  require('smooth-scroll')('a[href*="#"]')
}

const Layout = ({ children, location, linksTo, noEnglish, title, lang, noSEO, description }) => (
  <StaticQuery
    query={graphql`
      query SiteTitle {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} location={location} />
        {!noSEO && (
          <Seo
            title={title}
            lang={lang}
            linksTo={linksTo}
            noEnglish={noEnglish}
            location={location}
            description={description}
          />
        )}
        <div>{children}</div>
        <Container fluid>
          <Row>
            <Col className="footer-col">
              <Footer pathname={location.pathname} linksTo={linksTo} noEnglish={noEnglish} />
            </Col>
            <ScrollButton />
          </Row>
        </Container>
      </>
    )}
  />
)

Layout.defaultProps = {
  noSEO: false,
}

export default Layout
